import { render, staticRenderFns } from "./IconGlyph.vue?vue&type=template&id=60ad2436"
import script from "./IconGlyph.vue?vue&type=script&lang=js"
export * from "./IconGlyph.vue?vue&type=script&lang=js"
import style0 from "./IconGlyph.vue?vue&type=style&index=0&id=60ad2436&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports